<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Báo cáo chi tiết Học sinh"
          :link="[
            {
              text: 'Chi tiết học sinh',
              href: '../busStudentAttendance'
            }
          ]"
        />
      </div>
      <div class="d-flex justify-end">
        <v-btn @click="openAddBusStudentAttendanceDialog" dark color="#0D47A1">
          <v-icon left>add</v-icon>Thêm điểm danh
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BusStudentTrackingFilter />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <BusStudentTrackingTable />
    </v-card>

    <BusStudentAttendanceNewDialog ref="bus-student-attendance-new-dialog" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BusStudentAttendanceFilter from '@/modules/bus/BusStudentAttendanceFilter.vue'
import BusStudentTrackingFilter from '@/modules/bus/BusStudentTrackingFilter.vue'
import BusStudentAttendanceTable from '@/modules/bus/BusStudentAttendanceTable.vue'
import BusStudentTrackingTable from '@/modules/bus/BusStudentTrackingTable.vue'
import BusStudentAttendanceNewDialog from './components/BusStudentAttendanceNewDialog.vue'

export default {
  components: {
    Breadcrumbs,
    BusStudentAttendanceFilter,
    BusStudentAttendanceTable,
    BusStudentTrackingTable,
    BusStudentTrackingFilter,
    BusStudentAttendanceNewDialog
  },
  methods: {
    openAddBusStudentAttendanceDialog() {
      this.$refs['bus-student-attendance-new-dialog'].openDialog()
    }
  }
}
</script>
